import { render, staticRenderFns } from "./DividerEdit.vue?vue&type=template&id=621797b7&scoped=true"
import script from "./DividerEdit.vue?vue&type=script&lang=js"
export * from "./DividerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621797b7",
  null
  
)

export default component.exports